import React, { useState } from 'react'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { useChainId } from 'wagmi'
import IconModalDivideLine from '~/assets/images/modal-divide-line.svg'
import { TRADE_STATUS } from '~/components/TradeDetail/types'
import { ApplicationModal } from '~/state/application/reducer'
import { getExplorerTransactionLink } from '~/utils/chain'
import { statusContent } from './config'
import {
  StyledModal,
  StyledSimpleModal,
  StyledSimpleModalBottom,
  StyledStatusHead,
} from './styled'
import { Props } from './types'

const SimpleStatus: React.FC<Props> = ({
  status,
  type = ApplicationModal.CLAIMING,
  txHash,
}) => {
  const { t } = useTranslation()
  const chainId = useChainId()

  const [timeLeft, setTimeLeft] = useState(60)

  return (
    <StyledModal>
      <StyledSimpleModal>
        <StyledStatusHead>
          <div className="status-with-tips">
            {statusContent(t)[status] && (
              <>
                <img src={statusContent(t)[status].icon} alt="" />
                <p className={`text ${status}`}>
                  {statusContent(t)[status].content[type]}
                </p>
              </>
            )}
          </div>
        </StyledStatusHead>
        {status === TRADE_STATUS.FAILED ? null : (
          <StyledSimpleModalBottom>
            <img src={IconModalDivideLine} alt="" className="divide-line" />
            {timeLeft > 0 && status === TRADE_STATUS.PENDING ? (
              <div className="bottom">
                <span className="text">{t('transaction_wait_tips')}</span>
                <Countdown
                  date={Date.now() + 60 * 1000}
                  onComplete={() => setTimeLeft(0)}
                  renderer={({ seconds }) =>
                    seconds > 0 && <span>{seconds}s</span>
                  }
                />
              </div>
            ) : (
              <a
                href={getExplorerTransactionLink(txHash, chainId)}
                className="link"
                target="_blank"
              >
                <button className="check-btn">{t('transaction_view')}</button>
              </a>
            )}
          </StyledSimpleModalBottom>
        )}
      </StyledSimpleModal>
    </StyledModal>
  )
}

export default SimpleStatus
